import { render } from "./3d-half-body.vue?vue&type=template&id=538eb122&scoped=true"
import script from "./3d-half-body.vue?vue&type=script&lang=js"
export * from "./3d-half-body.vue?vue&type=script&lang=js"

import "./3d-half-body.vue?vue&type=style&index=0&id=538eb122&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538eb122"]])

export default __exports__